import { useState, useCallback } from 'react';
import { CarveOutView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing carve-out dialog state
 */
export function useCarveOutDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingCarveOut, setEditingCarveOut] = useState<CarveOutView | null>(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const handleAddCarveOut = useCallback(() => {
    setEditingCarveOut(null);
    setDialogOpen(true);
  }, []);

  const handleEditCarveOut = useCallback((carveOut: CarveOutView) => {
    setEditingCarveOut(carveOut);
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
    setEditingCarveOut(null);
  }, []);

  const handleOpenHelpDialog = useCallback(() => {
    setHelpDialogOpen(true);
  }, []);

  const handleCloseHelpDialog = useCallback(() => {
    setHelpDialogOpen(false);
  }, []);

  return {
    dialogOpen,
    editingCarveOut,
    helpDialogOpen,
    handleAddCarveOut,
    handleEditCarveOut,
    handleCloseDialog,
    handleOpenHelpDialog,
    handleCloseHelpDialog,
  };
}
